import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { app, login, register1, register2, register3, register4, thankYou } from "./routes";
import { Register1, Register2, Register3, Register4 } from "pages/Auth/Register";

const CreateRouter = () => {

    return (
        <>
            <Routes>
                <Route path={register1} element={
                    <Register1 />
                } />
                <Route path={register2} element={
                    <Register2 />
                } />
                <Route path={register3} element={
                    <Register3 />
                } />
                <Route path={"/"} element={
                    <Navigate to={app.register1} />
                } />
            </Routes>
        </>
    );
}

export default CreateRouter
